__turbopack_context__.v({
  "accordionContainer": "accordionItem-module-scss-module__h3TInG__accordionContainer",
  "accordionItem": "accordionItem-module-scss-module__h3TInG__accordionItem",
  "accordionItemBtn": "accordionItem-module-scss-module__h3TInG__accordionItemBtn",
  "accordionPanel": "accordionItem-module-scss-module__h3TInG__accordionPanel",
  "selected": "accordionItem-module-scss-module__h3TInG__selected",
});
